import { useEffect, useState } from "react";
import PanelLayout from "../../panelComponents/PanelLayout/PanelLayout"
import { useNavigate } from "react-router-dom";
import authService from "../../../service/auth";
import { FilterDropdown, FilterInput, List, ListBody, ListFilter, ListWrapper } from "../../../BTUI/List";
import { showDatetime } from "../../../utils/formatter";
import { useSelector } from "react-redux";


const MessagesList = () => {
    const [clientMessage, setClientMessage] = useState([]);
    const [filterList, setFilterList] = useState({});
    const navigate = useNavigate()
    
    useEffect(()=>{
        authService.userMsgListCount()
            .then(res => {
                setClientMessage(res?.data?.response?.list)
            })
            .catch(err => {
                console.log('Error in Get Client Messages', err)
            })
    },[])

    const handleFiltersChange = (name,value) => {
        setFilterList({
            ...filterList,
            [name]: value
        })
        console.log(name, value)
    }

    return<PanelLayout>
        {/* <Container> */}
            <ListWrapper style={{width:'100%',flexGrow:1}} title="Messages">
                {/* <ListFilter>
                    <FilterInput 
                        name="search"
                        label="Search" 
                        hint="Search"
                        value={filterList?.search}
                        handleChange={handleFiltersChange}
                    />
                    <FilterDropdown 
                        label="Dropdown"
                        name="dropdown"
                        selected={filterList?.dropdown}
                        options={{list: MessageListThead, name: 'title',code:'title'}}
                        handleChange={handleFiltersChange}
                    />
                    <FilterInput 
                        name="search"
                        label="Search" 
                        hint="Search"
                        value={filterList?.search}
                        handleChange={handleFiltersChange}
                    />
                    <FilterDropdown 
                        label="Dropdown"
                        name="dropdown"
                        selected={filterList?.dropdown}
                        options={{list: MessageListThead, name: 'title',code:'title'}}
                        handleChange={handleFiltersChange}
                    />
                    <FilterInput 
                        name="search"
                        label="Search" 
                        hint="Search"
                        value={filterList?.search}
                        handleChange={handleFiltersChange}
                    />
                    <FilterDropdown 
                        label="Dropdown"
                        name="dropdown"
                        selected={filterList?.dropdown}
                        options={{list: MessageListThead, name: 'title',code:'title'}}
                        handleChange={handleFiltersChange}
                    />
                    <FilterInput 
                        name="search"
                        label="Search" 
                        hint="Search"
                        value={filterList?.search}
                        handleChange={handleFiltersChange}
                    />
                    <FilterDropdown 
                        label="Dropdown"
                        name="dropdown"
                        selected={filterList?.dropdown}
                        options={{list: MessageListThead, name: 'title',code:'title'}}
                        handleChange={handleFiltersChange}
                    />
                </ListFilter> */}
                <List 
                    thead={MessageListThead}>
                    
                    <ListBody>
                        {clientMessage?.length>0 ? clientMessage?.map((row,index)=>{
                                return <tr key={index} style={{cursor: 'pointer'}} onClick={()=>navigate('/executive/message/'+row?.user_id)}> 
                                <td>{row?.firstname || row?.user_email} {row?.lastname}</td>
                                <td>{row?.client_last_msg}</td>
                                <td>{row?.client_last_msg_time && showDatetime(row?.client_last_msg_time)}</td>
                                <td className={`tax-list-msg-count`}><p className={`${row?.client_message_count>0 ? 'green':'grey'}`}><span>{row?.client_message_count}</span></p></td>
                            </tr>
                        }) : <p style={{textAlign: 'center', marginTop: '20px'}}>No Record Found</p>}
                    </ListBody>
                </List>
            </ListWrapper>
        {/* </Container> */}
    </PanelLayout>
}

export default MessagesList


const MessageListThead = [
    {
        title:'Username',
        width:'30%'
    },
    {
        title:'Last Message',
        width:'30%'
    },
    {
        title:'Last Message Time',
        width:'30%'
    },
    {
        title:'New Messages',
        width:'10%'
    },

];